import { getYtdDateRange } from '../utils/dateRanges';

/**
 * Major indices / assets shown on the Market overview cards + comparison chart.
 * Ordered for a 3×2 grid: equities row, then small-cap / gold / bitcoin.
 */
export const MARKET_INDEX_SYMBOLS = ['SPY', 'QQQ', 'DIA', 'IWM', 'IAU', 'BTCUSD'];

/** Display names and colors for market indices */
export const MARKET_INDEX_CONFIG = {
  SPY: { name: 'S&P 500', color: 'chartUp' },
  QQQ: { name: 'Nasdaq', color: 'primary' },
  DIA: { name: 'Dow Jones', color: '#F97316' }, // orange
  IWM: { name: 'Russell 2000', color: 'info' },
  IAU: { name: 'Gold', color: '#FACC15' }, // yellow
  BTCUSD: { name: 'Bitcoin', color: '#DB2777' }, // darker pink
};

/**
 * Shared Market Overview chart + relative-strength windows.
 * barsback sized for recent RS accuracy without over-fetching.
 * YTD uses a calendar date range (see resolveMarketOverviewBarQuery).
 */
export const MARKET_OVERVIEW_TIME_FRAMES = [
  // Labels are review windows, not bar sizes. "Today" is a session of 5-minute bars.
  // "1 Day" on the trade chart is a daily candle. Keys stay stable for saved state.
  { key: '1D', label: 'Today', interval: 5, unit: 'Minute', barsback: 200, minBars: 20 },
  { key: '1W', label: 'Week', interval: 30, unit: 'Minute', barsback: 80, minBars: 16 },
  { key: '1M', label: 'Month', interval: 1, unit: 'Daily', barsback: 21, minBars: 10 },
  { key: '3M', label: 'Quarter', interval: 1, unit: 'Daily', barsback: 63, minBars: 20 },
  { key: '6M', label: '6M', interval: 1, unit: 'Daily', barsback: 126, minBars: 30 },
  { key: 'YTD', label: 'YTD', interval: 1, unit: 'Daily', range: 'ytd', barsback: 260, minBars: 10 },
  { key: '1Y', label: '1Y', interval: 1, unit: 'Daily', barsback: 252, minBars: 40 },
];

export function getMarketOverviewTimeFrame(key) {
  return MARKET_OVERVIEW_TIME_FRAMES.find((tf) => tf.key === key) || MARKET_OVERVIEW_TIME_FRAMES[0];
}

/**
 * Build bars-fetch args for a Market Overview timeframe.
 * YTD sends firstdate/lastdate (mutually exclusive with barsback).
 */
export function resolveMarketOverviewBarQuery(tf, now = new Date()) {
  if (!tf) return {};
  if (tf.range === 'ytd') {
    const { firstdate, lastdate } = getYtdDateRange(now);
    return { firstdate, lastdate };
  }
  return { barsback: tf.barsback };
}
